export default __webpack_public_path__ + "static/media/active-dashboard-icon.1bd268e3.svg";